export default {
    '2b-diagram2': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'The system of documenting property injects life into assets and makes them generate capital',
            'two': 'Represents it as a document',
            'three': 'Allows it to be used as collateral for credit',
            'four': 'Connects it to the rest of the economy',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram2/i18n/en.js